module.exports = __webpack_public_path__ + "static/media/filters.eb0bdcbc.svg";